<template>
	<el-drawer
		:title="(!team_institution_id ? '添加' : '编辑') + '团长'"
		:wrapperClosable="false"
		:append-to-body="true"
		:visible.sync="dialogVisible"
		size="600px"
		:before-close="handleClose"
	>
		<div class="formBox">
			<div class="flex-row-align-center">
				<div class="icon"></div>
				<div class="font-h4-medium yx-color-text-primary ml-10">团长信息</div>
			</div>
			<el-form class="mt-16" :model="form" ref="ruleForm" label-width="130px">
				<el-form-item prop="institution_name">
					<div slot="label">
						<span class="yx-color-danger mr-4">*</span>
						<span>团长名称</span>
					</div>
					<el-input v-model="form.institution_name" maxlength="30" placeholder="请输入团长名称" />
				</el-form-item>
				<el-form-item prop="main_url">
					<div slot="label">
						<span class="yx-color-danger mr-4">*</span>
						<span>团长主页链接</span>
					</div>
					<el-input type="textarea" v-model="form.main_url" placeholder="请输入团长主页链接" />
					<div class="font-h6-regular yx-color-primary cursor-pointer" @click="goToUrl">如何获取团长链接？</div>
				</el-form-item>
				<el-form-item prop="userIds" v-if="$auth.hasPermi('system:cooperativeColonel:switch')">
					<div slot="label">
						<span class="yx-color-danger mr-4">*</span>
						<span>跟进人</span>
					</div>
					<el-select v-model="form.userIds" clearable placeholder="请选择跟进人" :multiple="manyPartnerToInstitution === '1'">
						<el-option v-for="item in partner_list" :key="item.userId" :label="item.name" :value="item.userId">
							<div class="flex flex-align-center">
								<span class="mr-8">{{ item.name }}</span>
								<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
								<el-tag v-else-if="item.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
							</div>
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="跟进人" v-else>
					<el-input :value="vuex_userInfo.partner_role_name" disabled />
				</el-form-item>
				<el-form-item label="主推类目">
					<el-select style="width: 100%" v-model="form.recommend_type" clearable multiple :multiple-limit="3" placeholder="请选择主推类目">
						<el-option v-for="item in cateList" :key="item.cate_id" :label="item.cate_name" :value="item.cate_id" />
					</el-select>
				</el-form-item>
				<el-form-item label="出单达人数">
					<el-input v-model="form.order_anchor_num" placeholder="请填写" />
				</el-form-item>
				<el-form-item label="出单商品数">
					<el-input v-model="form.order_product_num" placeholder="请填写" />
				</el-form-item>
				<el-form-item label="总销售额">
					<el-input v-model="form.sale_amount" placeholder="请填写">
						<template slot="prepend">￥</template>
					</el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="form.remark" placeholder="请填写" />
				</el-form-item>
			</el-form>
		</div>
		<div class="bott">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="submit" :disabled="!isDisable">保存</el-button>
		</div>
	</el-drawer>
</template>

<script>
import { mapState } from 'vuex';
import throttle from 'lodash/throttle';
import { drRoleType, PLATFORM_DY } from '@/utils/dataMap';
import { commonList } from '@/api/cooperationProgress';
import { getCateList } from '@/api/talentCRM';
import { addInstitution, updateInstitution, getInstitutionInfo, GetRule } from '@/api/secondColonelManage';

export default {
	name: 'partnerDialog',
	data() {
		return {
			dialogVisible: false,
			partner_list: [],
			cateList: [],
			form: {
				platform_id: +PLATFORM_DY.value,
				institution_name: '',
				main_url: '',
				userIds: '',
				recommend_type: [],
				order_anchor_num: '',
				order_product_num: '',
				sale_amount: '',
				remark: '',
			},
			team_institution_id: '',
			manyPartnerToInstitution: '0',
		};
	},
	computed: {
		...mapState(['vuex_userInfo']),
		isDisable({ form }) {
			const userIdCheck = this.$auth.hasPermi('system:cooperativeColonel:switch') ? form.userIds.length : true;
			return form.institution_name && form.main_url && userIdCheck;
		},
	},
	methods: {
		show(team_institution_id = '') {
			this.GetRule();
			this.team_institution_id = team_institution_id;
			this.getCateList();
			this.dialogVisible = true;
		},
		async GetRule() {
			const { platformId } = this;
			const { manyPartnerToInstitution = '0' } = await GetRule({ platformId });
			this.manyPartnerToInstitution = `${manyPartnerToInstitution}`;
			if (this.manyPartnerToInstitution === '1') {
				this.form.userIds = [];
			} else {
				this.form.userIds = '';
			}
			this.partnerList();
			if (this.team_institution_id) this.getInstitutionInfo();
		},
		handleClose() {
			this.form = {
				platform_id: +PLATFORM_DY.value,
				institution_name: '',
				main_url: '',
				userIds: '',
				recommend_type: [],
				order_anchor_num: '',
				order_product_num: '',
				sale_amount: '',
				remark: '',
			};
			this.team_institution_id = '';
			this.$refs.ruleForm.resetFields();
			this.dialogVisible = false;
		},
		async getInstitutionInfo() {
			const { team_institution_id: id } = this;
			const { code, data = {} } = await getInstitutionInfo({ id });
			if (code !== 0) return;
			Object.keys(this.form).forEach(key => {
				if (key === 'recommend_type') {
					this.form[key] = data[key].filter(item => item !== '');
				} else if (key === 'platform_id') {
					this.form[key] = +data[key];
				} else if (key === 'userIds') {
					//允许多跟进达人规则支持多选，否则单选
					this.form[key] = this.manyPartnerToInstitution === '1' ? data['userIds'] || [] : `${data['userIds'][0]}`;
				} else {
					this.form[key] = data[key];
				}
			});
		},
		async getCateList() {
			const { code, data } = await getCateList();
			if (code !== 0) return;
			this.cateList = data;
		},
		async partnerList() {
			const { code, data = [] } = await commonList({ role_id: drRoleType.id, all_status: 1 });
			if (code !== 0) return;
			this.partner_list = data;
			if (!this.$auth.hasPermi('system:cooperativeColonel:switch')) {
				let name = this.vuex_userInfo.partner_role_name;
				let userIds = [];
				this.partner_list.forEach(item => {
					if (item.name === name) {
						userIds.push(item.userId);
					}
				});
				this.form.userIds = userIds[0];
			}
		},
		goToUrl() {
			window.open('https://chaoyongtuan.yuque.com/books/share/62382192-9a6a-412f-bf5e-2d2fbba5b03e/ugvyhr');
		},
		submit: throttle(function () {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				const { form, team_institution_id } = this;
				const recommend_type = form.recommend_type.join();
				let { order_anchor_num, order_product_num, sale_amount, userIds } = form;
				order_anchor_num = +order_anchor_num;
				order_product_num = +order_product_num;
				sale_amount = +sale_amount;
				const params = {
					...form,
					recommend_type,
					order_anchor_num,
					order_product_num,
					sale_amount,
					userIds: Array.isArray(userIds) ? userIds : [userIds],
				};
				const { code } = await (!team_institution_id ? addInstitution(params) : updateInstitution({ ...params, team_institution_id }));
				if (code !== 0) return;
				this.$message.success(`${!team_institution_id ? '添加' : '编辑'}成功`);
				this.$emit('getList');
				this.handleClose();
			});
		}, 1000),
	},
};
</script>

<style lang="less" scoped>
.formBox {
	padding: 24px 24px 80px 24px;
	.icon {
		width: 4px;
		height: 16px;
		border-radius: 14px;
		background-color: @color-primary;
	}
	/deep/ .el-select {
		width: 100%;
	}
}
.link {
	color: @color-primary;
	font-size: 13px;
	line-height: 13px;
	margin-top: 8px;
	cursor: pointer;
}
.bott {
	position: absolute;
	bottom: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	/deep/ .el-button--small {
		padding: 0 28px;
	}
}
</style>
